import Vue from "vue";
import VueRouter from "vue-router";
import home from '@/view/home/home'

Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        component: home,
        meta: {
            title: "有明仿真-一个专注于CAE技术分享的博客平台"
        },
        children: [
            {
                path: "/",
                component: resolve => require(["@/view/home/index.vue"], resolve),
                meta: {
                    title: "有明仿真-一个专注于CAE技术分享的博客平台"
                }
            },
            // {

            //     path: "/links",
            //     component: resolve => require(["@/view/link/index.vue"], resolve),
            //     meta: {
            //         title: "友情链接"
            //     }
            // },
            {
                path: "/article/:articleId",
                component: resolve => require(["@/view/article/index.vue"], resolve),
            },
            {
                path: "/message",
                component: resolve => require(["@/view/message/index.vue"], resolve),
                meta: {
                    title: "留言板"
                }
            },
            {
                path: "/about",
                component: resolve => require(["@/view/about/index.vue"], resolve),
                meta: {
                    title: "公告"
                }
            },
            {
                path: "/newposts",
                component: resolve => require(["@/view/article/Add"], resolve),
            },
            // {
            //     path: "/archive",
            //     component: resolve => require(["@/view/archive/index"], resolve),
            //     meta: {
            //         title: "文章归档"
            //     }
            // },
            {
                path: "/categorys",
                component: resolve => require(["@/view/category/Category.vue"], resolve),
                meta: {
                    title: "文章分类"
                }
            },
            {
                path: "/tag",
                component: resolve => require(["@/view/tag/Tag"], resolve),
                meta: {
                    title: "文章标签"
                }
            },
            // {
            //     path: "/say",
            //     component: resolve => require(["@/view/say/index"], resolve),
            //     meta: {
            //         title: "说说"
            //     }
            // },
            // {
            //     path: "/newSays",
            //     component: resolve => require(["@/view/say/Add"], resolve),
            //     meta: {
            //         title: "添加说说"
            //     }
            // },
            {
                path: "/forum",
                component: resolve => require(["@/view/forum/index"], resolve),
                meta: {
                    title: "问答"
                }
            },
            {
                path: "/sponsor",
                component: resolve => require(["@/view/sponsor/index"], resolve),
                meta: {
                    title: "打赏名单"
                }
            },
            {
                path: "/im",
                component: resolve => require(["@/view/im/index"], resolve),
                meta: {
                    title: "有明仿真-一个专注于CAE技术分享的博客平台"
                }
            },
            {
                path: "/hot",
                component: resolve => require(["@/view/search/Hot.vue"], resolve),
                meta: {
                    title: "网站热搜"
                }
            },
            {
                name: "notice",
                path: "/notice",
                component: resolve => require(["@/view/notice/index.vue"], resolve),
                meta: {
                    title: "有明仿真-一个专注于CAE技术分享的博客平台"
                }
            },
            {
                path: "/navigation",
                component: resolve => require(["@/view/navigation/index.vue"], resolve),
                meta: {
                    title: "网站导航"
                }
            },
            {
                path: "/subject",
                name: 'Subject',
                component: () => import('@/view/subject/index.vue'),
                meta: {
                    title: "专栏"
                }
            },
            {
                path: "/subject/articles/:categoryId",
                name: 'SubjectArticles',
                component: () => import('@/view/subject/articleList.vue'),
                props: true
            },
            {
                path: "/user",
                name: "user",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "有明仿真-一个专注于CAE技术分享的博客平台"
                }
            },
            {
                path: "/user/manage/article",
                name: "ContentManage",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "内容管理"
                }
            },
            {
                path: "/user/manage/comment",
                name: "CommentManage",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "评论管理"
                }
            },
            {
                path: "/user/manage/category",
                name: "CategoryManage",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "专栏管理"
                }
            },
            {
                path: "/user/manage/category/:categoryId",
                name: "CategoryArticleManage",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                props: true,
                meta: {
                    title: "专栏文章管理"
                }
            },
            {
                path: "/user/data/work",
                name: "WorkData",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "作品数据"
                }
            },
            {
                path: "/user/data/income",
                name: "IncomeData",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "收益数据"
                }
            },
            {
                path: "/user/data/fans",
                name: "FansData",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "粉丝数据"
                }
            },
            {
                path: "/user/data/weekly",
                name: "WeeklySummary",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "一周小结"
                }
            },
            {
                path: "/user/activity/list",
                name: "ActivityList",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "活动列表"
                }
            },
            {
                path: "/user/activity/submit",
                name: "SubmitManage",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "投稿管理"
                }
            },
            {
                path: "/user/activity/coupon",
                name: "CouponManage",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "流量券管理"
                }
            },
            {
                path: "/user/rights/level",
                name: "LevelRights",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "等级权益"
                }
            },
            {
                path: "/user/personal",
                component: resolve => require(["@/view/user/single/PersonalInfo.vue"], resolve),
                meta: {
                    title: "个人主页"
                }
            },
            {
                path: "/user/single/recharge",
                component: resolve => require(["@/view/user/single/Recharge.vue"], resolve),
                meta: {
                    title: "账户充值"
                }
            },
            {
                path: "/user_main",
                component: resolve => require(["@/view/user/UserMain.vue"], resolve),
                meta: {
                    title: "有明仿真-一个专注于CAE技术分享的博客平台"
                }
            },

        ],
    },
    {
        path: '/search',
        name: 'Search',
        component: () => import('@/view/search/index.vue'),
        meta: {
            title: '搜索结果'  // 设置页面标题
        }
    },
    {
        path: "*",
        name: "NotFound",
        component: () => import("@/view/404/404.vue"),
    }
];

const router = new VueRouter({
    mode: "history",
    scrollBehavior: () => ({ y: 0 }),
    routes
});
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {    
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    // 检查路由是否存在
    if (to.matched.length === 0) {
        console.error('路由不存在:', to.path);
        next('/404');
    } else {
        next();
    }
});
export default router;
